import React, { ReactNode } from 'react'

import { Table, Tr, Td, EmptyRow, Spinner } from '@components'

interface DashboardTableProps<T> {
	title: string
	columns: { label: string }[]
	data: T[] | undefined
	isLoading: boolean
	emptyMessage?: string
	renderRow: (item: T, index: number) => ReactNode
	filters?: ReactNode
	className?: string
	action?: ReactNode
}

export function DashboardTable<T>({
	title,
	columns,
	data,
	isLoading,
	emptyMessage = 'Nenhum dado encontrado',
	renderRow,
	filters,
	className = '',
	action,
}: DashboardTableProps<T>) {
	const renderTableBody = () => {
		if (isLoading) {
			return (
				<Tr>
					<Td colSpan={columns.length} className='p-0'>
						<div className='flex w-full justify-center items-center py-10 text-gray-400'>
							<Spinner size='ssm' />
						</div>
					</Td>
				</Tr>
			)
		}

		if (data && data.length > 0) {
			return data.map((item, index) => renderRow(item, index))
		}

		return <EmptyRow tdAmount={columns.length} message={emptyMessage} />
	}

	return (
		<div
			className={`px-6 py-6 rounded-xl bg-white transform hover:scale-105 transition duration-300 h-fit border-[1px] border-gray-250 ${className}`}
		>
			<div className='flex justify-between items-center pb-5'>
				<h3 className='font-600 text-base text-gray-800'>{title}</h3>
				{action && <div>{action}</div>}
			</div>

			{filters && (
				<div className='grid grid-cols-1 md:grid-cols-3 gap-4 mb-4 w-full'>
					{filters}
				</div>
			)}

			<Table
				css='min-h-[215px] border-none shadow-none'
				thtCss='shadow-none'
				thCss='px-[12px] text-[14px] text-gray-850'
				variant='gray'
				th={columns}
			>
				{renderTableBody()}
			</Table>
		</div>
	)
}
